import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { ProviderType } from 'src/types/provider';
import { tabs } from './constants';

export interface TopBlockPropsType {
    data: ProviderType | null;
    idProvider: string | undefined;
    newProvider: boolean;
    disableEdit: boolean;
    handleSave: () => void;
    activeTab: string;
    handleChangeTab: (value: string) => void;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    if (props.newProvider) {
        return null;
    }

    return (
        <>
            <BodyTopBlock
                tabs={tabs}
                selectTab={!props.newProvider ? props.activeTab : undefined}
                onChangeTab={!props.newProvider ? props.handleChangeTab : undefined}
                actions={[
                    {
                        label: translate(
                            props.newProvider ? 'providerDetail.action.create' : 'providerDetail.action.save'
                        ),
                        onClick: () => props.handleSave(),
                        hidden: props.disableEdit,
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
